import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { merchantPaymentsService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

type paymentMethodProps = {
	userId: string;
	paymentMethodId: string;
	onSuccess?: Function;
	onError?: Function;
};

const useRemoveMerchantPaymentMethod = ({ refetch }) => {
	const dispatch = useDispatch();

	return useMutation(
		({ userId, paymentMethodId }: paymentMethodProps) => {
			return merchantPaymentsService.deleteMerchantPaymentMethod({
				userId,
				paymentMethodId,
			});
		},
		{
			onSuccess(result, { onSuccess }) {
				dispatch(
					uiActions.showSuccessNotification({
						title: "Payment Method has been deleted",
					}),
				);
				onSuccess?.(result);
				refetch();
			},
			onError(error: ErrorResponse, { onError }) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
				onError?.(error);
			},
		},
	);
};

export default useRemoveMerchantPaymentMethod;
